module.exports = __webpack_public_path__ + "static/img/product_4_1.388c56b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/product_4_1.png
// module id = 2OVL
// module chunks = 34